import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import Input from "../components/Input";
import Button from "../components/Button";
import PHIcon from "../Images/PharmacyHalo_Yellow.ico";

// Get the API manager route from environment variable
const apiManagerRoute = import.meta.env.VITE_APP_API_MANAGER_ROUTE || 'managerRegisterV137';

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [token, setCode] = useState("");
  const [password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate(); 

  const passwordRequirements = [
    {
      key: "minLength",
      text: "Minimum 8 characters",
      isValid: password.length >= 8,
    },
    {
      key: "upperCase",
      text: "At least one uppercase letter",
      isValid: /[A-Z]/.test(password),
    },
    {
      key: "lowerCase",
      text: "At least one lowercase letter",
      isValid: /[a-z]/.test(password),
    },
    {
      key: "digit",
      text: "At least one digit",
      isValid: /[0-9]/.test(password),
    },
    {
      key: "specialChar",
      text: "At least one special character",
      isValid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    },
  ];

  const handleSendCode = async () => {
    try {
      await apiService.apiRequest(`/${apiManagerRoute}/ResetManager`, "POST", {
        email,
      });
      setIsCodeSent(true);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleResetPassword = async () => {
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (!passwordRequirements.every((req) => req.isValid)) {
      setError("Password does not meet all requirements.");
      return;
    }

    try {
      await apiService.apiRequest(
        `/${apiManagerRoute}/ValidateTokenManager`,
        "POST",
        {
          password,
          token,
          email,
        }
      );
      setSuccess(true);
      setError("");

      setTimeout(() => {
        navigate("/login");
      }, 2000); 
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-md">
        <img
          src={PHIcon}
          alt="Pharmacy Halo Icon"
          className="mx-auto w-12 h-12 rounded-xl border border-gray-300"
          style={{ marginBottom: "5px" }}
        />
        <h1
          className="text-2xl font-bold text-center"
          style={{ marginTop: "0", marginBottom: "10px" }}
        >
          {isCodeSent ? "Reset Your Password" : "Request Reset Code"}
        </h1>

        {!isCodeSent ? (
          <div>
            <Input
              id="email"
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={error}
            />
            <Button onClick={handleSendCode} className="">
              Send Reset Code
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <Input
              id="code"
              type="text"
              placeholder="6-Digit Code"
              value={token}
              onChange={(e) => setCode(e.target.value)}
            />
            <Input
              id="password"
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <div className="flex justify-center">
              <ul className="text-sm text-gray-600 mt-4 mb-4 space-y-2">
                {passwordRequirements.map((req) => (
                  <li key={req.key} className="flex items-center space-x-2">
                    <span
                      className={
                        req.isValid ? "text-green-500" : "text-red-500"
                      }
                    >
                      {req.isValid ? "✔" : "✖"}
                    </span>
                    <span>{req.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Input
              id="confirm-password"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button onClick={handleResetPassword}>Reset Password</Button>
          </div>
        )}
        {error && <p className="text-red-500 text-center mt-4">{error}</p>}
        {success && (
          <p className="text-green-500 text-center mt-4">
            Password reset successfully! Redirecting to login...
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
